// © 2015-2021 WDNA - All Rights Reserved
import { History, createHashHistory } from 'history';

const history: History = createHashHistory();

export default history;
